import { Group, Text } from '@mantine/core'
import { IconUsers } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'

type SpaceRemainingCountProps = {
  count: number
}

export const SpaceRemainingCount = ({ count }: SpaceRemainingCountProps) => {
  return (
    <Group gap="xs" wrap="nowrap">
      <IconUsers size={16} color="var(--mantine-color-orange-6)" stroke={3} />

      <Text size="sm" fw={600}>
        <FormattedMessage
          id="workspace.members.space.remaining"
          values={{
            count
          }}
        />
      </Text>
    </Group>
  )
}
